import SharedWidgets from "../classes/SharedWidgets";

const defaultState = () => ({
  data: []
});

const state = defaultState();

// getters
const getters = {
  widgets: (state, getters) => {
    if (!(state.data instanceof Array) || !state.data.length) {
      return state.data;
    }
    return state.data
      .sort((a, b) => {
        if (a.enabled && !b.enabled) {
          return -1;
        }
        if (!a.enabled && b.enabled) {
          return 1;
        }
        return 0;
      })
      .sort((a, b) => (a.enabled !== b.enabled ? 0 : a.name > b.name ? 1 : -1));
  }
};

// actions
const actions = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  getData(state, variables = {}) {
    return SharedWidgets.getDataList(variables);
  },
  shared_widgets_list(state, data) {
    state.commit("setData", data);
  }
};

// mutations
const mutations = {
  setData(state, data) {
    state.data = SharedWidgets.getSelfList(data);
  },
  addFirst(state) {
    state.data.unshift(new SharedWidgets());
  },
  removeEmptyModel(state) {
    state.data = state.data.filter(v => v.uuid);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
